
import { Placement } from '@post-office/placements-frontend/jira-space-dashboard-guide';
export default Placement;
